import { GROUP } from '../EnumTypes/ActionEnumTypes';
import { Connector } from 'Modules/GroupModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';

const init = () => ({
  type: GROUP.GET_GROUP_INIT,
});

const success = (group) => ({
  type: GROUP.GET_GROUP_SUCCESS,
  payload: {
    group,
  },
});

const failure = () => ({
  type: GROUP.GET_GROUP_FAILURE,
});

const getGroup = () => async (dispatch) => {
  dispatch(init());
  try {
    dispatch(ViewManagementModule.Actions.showLoader());
    const { data } = await Connector.getGroup();
    dispatch(success(data.groupDtos));
    dispatch(ViewManagementModule.Actions.hideLoader());
  } catch (err) {
    dispatch(ViewManagementModule.Actions.hideLoader());
    dispatch(failure());
  }
};

export default getGroup;
